import React from "react";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

export default ({ label, placeholder, endAdornment }) => (
    <TextField label={label}
               margin="dense"
               disabled={true}
               InputProps={endAdornment && { endAdornment: <InputAdornment position="end">{endAdornment}</InputAdornment> }}
               value={placeholder}
               fullWidth
               InputLabelProps={{ shrink: true }}
               variant="outlined" />
);



// WEBPACK FOOTER //
// ./src/components/InfoInput.js